/**
 * @generated SignedSource<<10a1d00d8a4150261e1e3f3606eeee91>>
 * @relayHash dcd3297245ca05bbeda09fec90ebf00b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aa8e23eec52cf0877b2e9bc90b3d730c86518b5fc0703529e7451266b56c0915

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HelpCenterProjectMappingOperationType = "MAP_PROJECTS" | "UNMAP_PROJECTS" | "%future added value";
export type HelpCenterProjectMappingUpdateInput = {
  helpCenterAri: string;
  operationType?: HelpCenterProjectMappingOperationType | null | undefined;
  projectIds?: ReadonlyArray<string> | null | undefined;
  syncNewProjects?: boolean | null | undefined;
};
export type useProjectMappingLinkUnlinkMutation$variables = {
  cloudId: string;
  input: HelpCenterProjectMappingUpdateInput;
};
export type useProjectMappingLinkUnlinkMutation$data = {
  readonly helpCenter: {
    readonly updateProjectMapping: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useProjectMappingLinkUnlinkMutation = {
  response: useProjectMappingLinkUnlinkMutation$data;
  variables: useProjectMappingLinkUnlinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterProjectMappingUpdatePayload",
        "kind": "LinkedField",
        "name": "updateProjectMapping",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useProjectMappingLinkUnlinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useProjectMappingLinkUnlinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "aa8e23eec52cf0877b2e9bc90b3d730c86518b5fc0703529e7451266b56c0915",
    "metadata": {},
    "name": "useProjectMappingLinkUnlinkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "286244c374967a1061533dc1b4d8a56d";

export default node;
